import Vue from 'vue'
import LazyHydrate from "vue-lazy-hydration"
Vue.component('LazyHydrate', LazyHydrate)

Vue.use(LazyHydrate)
